/** Estados `partner_pickup_packages.status` (rol pickup). */
export const PARTNER_PICKUP_STATUS_ORDER = ['asignado', 'recibido', 'entregado'];

export const PARTNER_PICKUP_STATUS_LABEL_ES = {
  asignado: 'Asignado',
  recibido: 'Recibido en punto',
  entregado: 'Entregado',
};

export const PARTNER_PICKUP_EVENT_LABEL_ES = {
  creado: 'Alta',
  estado: 'Cambio de estado',
};
